<template>
  <div style=" color: #666;overflow: hidden;">
    <div class="style-row">
      <Checkbox v-model="buttonIcon" :binary="true" style="margin-right: 10px"/>
      <label for="label">Show Button Icon</label>
    </div>

    <div class="style-row">
      <Button icon='pi pi-pencil' @click="openDialog=true" style="margin-right: 10px"/>
      <label for="label">Icons</label>
    </div>

    <Dialog v-model:visible="openDialog" style="width: 50vw" header="Select Icon">
      <div class="icon-search">
        <InputText v-model="searchQuery" placeholder="Search icons" />
      </div>

      <div class="icon-grid">
        <div v-for="icon in filteredIcons" :key="icon.name" class="icon-item" @click="selectIcon(icon)">
          <div class="icon-container">
            <i :class="icon.icon"></i>
          </div>
        </div>
      </div>
    </Dialog>


    <div class="style-row">
      <span class="label">Button Text</span>
      <InputText placeholder="Enter Button Text" inputId="buttonText" v-model="buttonText" style="width:200px;"/>
    </div>

    <div class="style-row">
      <span class="label">Button Color</span>
      <ColorButton :width="`100px`" :color="buttonColor ?? '#000'" @click="$refs.buttonPickerVisible.toggle($event)" style="width:200px;"/>
      <OverlayPanel ref="buttonPickerVisible">
        <ColorPicker v-model="buttonColor"/>
      </OverlayPanel>
    </div>

    <div class="style-row">
      <span class="label">Button Type</span>
      <Dropdown v-model="buttonType" :options="buttonEvents" optionLabel="label" optionValue="value" style="width: 200px;" />
    </div>

    <div v-if="buttonType === 'ai'">
      <div class="style-row">
        <label for="label">AI Endpoint</label>
        <InputText type="text" v-model="buttonAIEndpoint" style="margin-left: 15px;width:200px;"/>
      </div>
    </div>

    <div v-if="buttonType === 'report'">
      <div class="style-row">
        <label for="label">Button Notes</label>
        <InputText type="text" v-model="buttonNotes" style="margin-left: 15px;width:200px;"/>
      </div>

      <div class="style-row" style="align-items: start">
        <label for="label">PDF Only Generation</label>
        <Checkbox v-model="generatePdf" binary style="margin-left: 15px;width:160px;" />
      </div>

      <div class="style-row" style="align-items: start">
        <label for="label">Reveal Slide Indices</label>
        <Textarea v-model="buttonRevealSlideIndices" style="margin-left: 15px;width:160px;" rows="5"/>
      </div>
    </div>
    <Idot/>
  </div>
</template>
<script setup lang="ts">
import {computed, defineEmits, ref} from 'vue'
import {useWidgetStore} from "@/store";
import {storeToRefs} from "pinia";
import ColorPicker from "@/components/ColorPicker/index.vue";
import ColorButton from "@/views/Editor/Toolbar/common/ColorButton.vue";
import { PrimeIcons } from 'primevue/api';
import StockImageElement from "@/views/components/element/StockImageElement/index.vue";
import FileManager from "@/views/components/element/FileManagerElement/index.vue";
import Idot from "@/views/Editor/Toolbar/common/IdotStyle.vue";


const widgetStore = useWidgetStore()
const {selectedWidget} = storeToRefs(widgetStore)
const openDialog = ref(false)
const searchQuery = ref('')

const allIcons: string[] = Object.keys(PrimeIcons)
const filteredIcons = computed(() => {
  return allIcons
      .filter(icon => icon.toLowerCase().includes(searchQuery.value.toLowerCase()))
      .map(icon => ({ name: icon, icon: PrimeIcons[icon] }))
})


const buttonText = computed({
  get() {
    return selectedWidget.value?.text !== 'Select data from Value Model' ? selectedWidget.value?.text : 'Button'
  },
  set(val) {
    selectedWidget.value.text = val
  }
})

const buttonIcon = computed({
  get() {
    return selectedWidget.value?.buttonIcon ?? true
  },
  set(val) {
    selectedWidget.value.buttonIcon = val
  }
})

const buttonColor = computed({
  get() {
    return selectedWidget.value?.buttonColor ?? '#2196F3'
  },
  set(val) {
    selectedWidget.value.buttonColor = val
  }
})

const buttonType = computed({
  get() {
    return selectedWidget.value?.buttonType ?? null
  },
  set(val) {
    selectedWidget.value.buttonType = val
  }
})

const buttonNotes = computed({
  get() {
    return selectedWidget.value?.buttonNotes ?? ''
  },
  set(val) {
    selectedWidget.value.buttonNotes = val
  }
})

const generatePdf = computed({
  get() {
    return selectedWidget.value?.generatePdf ?? false
  },
  set(val) {
    selectedWidget.value.generatePdf = val
  }
})


const buttonRevealSlideIndices = computed({
  get() {
    return selectedWidget.value?.buttonRevealSlideIndices ?? ''
  },
  set(val) {
    selectedWidget.value.buttonRevealSlideIndices = val
  }
})

const buttonAIEndpoint = computed({
  get() {
    return selectedWidget.value?.buttonAIEndpoint ?? ''
  },
  set(val) {
    selectedWidget.value.buttonAIEndpoint = val
  }
})

const buttonEvents = [
    { label: 'JSpreadsheet Sync Event', value: 'jspreadsheet-sync' },
    {label: 'Save UVP', value: 'save'},
    {label: 'Generate Report', value: 'report'},
    {label: 'AI', value: 'ai'},
    {label: 'Calculator PDF', value: 'calculator-pdf'},
]

const selectIcon = (icon: { name: string; icon: string }) => {
  selectedWidget.value.buttonIconImg = icon.icon;
  openDialog.value = false;
};

</script>

<style scoped>
span.label { display: inline-block; width: 100px }
.style-row { margin-top: 15px; width: 300px; align-items: center; display: flex  }

:deep(.p-highlight span) { z-index: 100; }
:deep(.p-selectbutton .p-button::before) {
  transition: none !important;
}

:deep(.p-dialog-content) {
  height: 500px;
}
:deep(.p-inputtext) {
  text-align: left !important;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns */
  grid-gap: 10px;
  row-gap: 30px;
  margin-top: 20px;
}

.icon-item {
  text-align: center;
  cursor: pointer;
}

.icon-container {
  display:flex;
  justify-content: center;
  flex-direction: column;
}
</style>
